export const styles = {
  title: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "rgb(17, 24, 39) ",
  },
};
